import React from "react";
import { uploadFile, saveData } from "../../../services/postAPIs";

export default function UploadBlock({ setUpUserBlockList }) {
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [enteredData, setEnteredData] = React.useState("");
  const [uploading, setUploading] = React.useState(false);
  const handleFile = (e) => {
    let data = e.target.files[0];
    setSelectedFile(data);
  };
  const handleUpload = async () => {
    setUploading(true);
    let res;
    if (selectedFile !== null) {
      const formData = new FormData();
      formData.append("file", selectedFile);
      try {
        res = await uploadFile(formData);
        let temp = {};
        if (res.data.result) {
          temp = {
            file: res.data.file,
            fileName: res.data.fileName,
            fileType: res.data.fileType,
            fileSize: res.data.fileSize,
            data: enteredData,
            userId: 0,
            isFile: true,
          };
          let resTwo = await saveData(temp);
          setSelectedFile(null);
          setEnteredData("");
          setUploading(false);
          setUpUserBlockList();
        }
      } catch (error) {}
    } else {
      let temp = {
        file: "text",
        fileName: "text",
        fileType: "text",
        fileSize: 0,
        data: enteredData,
        userId: 0,
        isFile: false,
      };
      let resTwo = await saveData(temp);
      setUpUserBlockList();
      setSelectedFile(null);
      setEnteredData("");
      setUploading(false);
    }
  };
  return (
    <div className="t-m-upload-block">
      <label htmlFor="upload" className="t-m-u-left">
        <input
          disabled={uploading}
          onChange={handleFile}
          type="file"
          id="upload"
        />
        <h6>{!selectedFile ? "Upload file" : selectedFile.name}</h6>
        {/* <p>Or Drag & Drop</p> */}
      </label>
      <div className="t-m-u-center">
        <div>
        <input
          value={enteredData}
          onChange={(e) => setEnteredData(e.target.value)}
          type="text"
          placeholder="Enter data...."
        />

        </div>
      </div>
      <div className="t-m-u-right">
        <div
          onClick={() => (!enteredData && !selectedFile ? console.log() : handleUpload())}
          className={!enteredData ? "disable-it" : ""}
        >
          <h6>{uploading ? "Saving..." : "Save data"}</h6>
          <button disabled={!enteredData && !selectedFile}>
            {uploading ? (
              <img src="https://img.icons8.com/windows/32/ffffff/upload-to-cloud.png" />
            ) : (
              <img src="https://img.icons8.com/metro/26/ffffff/save.png" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
